import React from 'react';
import { Link } from 'react-router-dom';

const relatedPages = [
  {
    label: 'Personvernerklæring',
    sublabel: 'GDPR & Personvern',
    desc: 'Les om hvordan NordPass samler inn, behandler og beskytter dine personopplysninger.',
    href: '/privacy-policy-personvern',
    accent: '#3B6FD4',
    tag: 'PERSONVERN'
  },
  {
    label: 'Ofte stilte spørsmål',
    sublabel: 'Hjelp & Support',
    desc: 'Finn svar på vanlige spørsmål om vilkår, abonnement, kansellering og refusjon.',
    href: '/faq',
    accent: '#10B981',
    tag: 'FAQ'
  },
  {
    label: 'Abonnementsportal',
    sublabel: 'Min konto',
    desc: 'Administrer ditt abonnement, betalingsmetoder, kjøretøy og kontoinnstillinger.',
    href: '/nord-pass-subscription-portal',
    accent: '#8B5CF6',
    tag: 'PORTAL'
  },
  {
    label: 'Kontakt oss',
    sublabel: 'Juridisk kontakt',
    desc: 'Kontakt NordPass AS for juridiske spørsmål, tvister eller klager på tjenestene.',
    href: '/nord-pass-contact-page',
    accent: '#F97316',
    tag: 'KONTAKT'
  }
];

const TermsRelatedPages = () => {
  return (
    <section
      style={{
        marginTop: '80px',
        paddingTop: '64px',
        borderTop: '2px solid rgba(255,255,255,0.06)'
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: '40px', display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ width: '4px', height: '40px', background: '#F97316' }} />
        <div>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.625rem',
              color: '#3B6FD4',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              marginBottom: '4px'
            }}
          >
            RELATERTE SIDER
          </div>
          <h2
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(1.5rem, 3vw, 2.25rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: 1,
              margin: 0
            }}
          >
            Juridiske ressurser
          </h2>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: '16px'
        }}
      >
        {relatedPages?.map((page, i) => (
          <Link
            key={i}
            to={page?.href}
            style={{ textDecoration: 'none' }}
          >
            <div
              style={{
                background: `${page?.accent}06`,
                border: `1px solid ${page?.accent}20`,
                borderTop: `3px solid ${page?.accent}`,
                padding: '24px',
                height: '100%',
                transition: 'all 200ms ease',
                transform: `rotate(${i % 2 === 0 ? '0.3deg' : '-0.3deg'})`
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = `${page?.accent}10`;
                e.currentTarget.style.transform = 'rotate(0deg) translateY(-3px)';
                e.currentTarget.style.boxShadow = `0 12px 32px rgba(0,0,0,0.3)`;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = `${page?.accent}06`;
                e.currentTarget.style.transform = `rotate(${i % 2 === 0 ? '0.3deg' : '-0.3deg'})`;
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div
                style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.5625rem',
                  color: page?.accent,
                  letterSpacing: '0.2em',
                  textTransform: 'uppercase',
                  marginBottom: '8px'
                }}
              >
                {page?.tag}
              </div>
              <div
                style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '1rem',
                  fontWeight: 800,
                  color: '#EEF0F2',
                  marginBottom: '4px',
                  letterSpacing: '-0.01em'
                }}
              >
                {page?.label}
              </div>
              <div
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.6875rem',
                  color: page?.accent,
                  marginBottom: '12px',
                  opacity: 0.8
                }}
              >
                {page?.sublabel}
              </div>
              <p
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.8125rem',
                  color: 'rgba(238,240,242,0.55)',
                  lineHeight: 1.6,
                  margin: '0 0 16px'
                }}
              >
                {page?.desc}
              </p>
              <span
                style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '0.6875rem',
                  fontWeight: 700,
                  color: page?.accent,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase'
                }}
              >
                Les mer →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default TermsRelatedPages;
